// @ts-nocheck
import { hubService } from '@/services';
import HubVM from '@/view-model/hub-management/HubVM';
const action = {
    resetHubInfo({ commit }) {
        commit('RESET_HUB_INFO');
    },
    async getHubInfo({ commit }, code) {
        const { data } = await hubService.getManagementHub(code);
        const payload = new HubVM(data);
        commit('GET_HUB_INFO', payload);
    },
};
export default action;
